import dayjs from "dayjs";

export default function formatCreatedAt(date, tooltip = false) {
  if (!date) return "-";

  const d = dayjs(date);

  if (tooltip) return "Criado em " + d.format("DD/MM/YY [às] HH[h]mm");

  return d.fromNow();
}
